<script setup lang="ts">
import DropdownBase from './DropdownBase.vue';

interface IDropdownOption {
  value: string | number;
}

const props = defineProps<{
  options?: IDropdownOption[];
  modelValue?: IDropdownOption;
  placeholder?: string;
  error?: string;
  label?: string;
  isRequired?: boolean;
  emptyMessage?: string;
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: IDropdownOption): void;
  (e: 'buttonClick'): void;
}>();
</script>

<template>
  <DropdownBase
    v-bind="{ options, error, label, isRequired, emptyMessage, modelValue }"
    @update:modelValue="(value) => $emit('update:modelValue', value)"
    @buttonClick="$emit('buttonClick')"
  >
    <template #button="{ show, hide }">
      <div class="dropdown-button__label">
        <slot v-if="modelValue" name="button" :option="modelValue" :show="show" :hide="hide"
          >{{ modelValue?.value }}
        </slot>
        <template v-else>{{ placeholder }}</template>
      </div>
    </template>

    <template #option="{ option }">
      <slot name="option" :option="option" />
    </template>
  </DropdownBase>
</template>

<style lang="stylus" scoped>
.dropdown-button
  &__label
    font-size 14px
    font-weight 400
    white-space nowrap
    overflow hidden
    text-overflow ellipsis
</style>
